module.exports = __webpack_public_path__ + "img/06.f1d30676.jpg";